var _desc, _ellipse, _g, _g2, _g3, _g4, _g5, _g6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPricingLicense1Switzerland(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "300px",
    height: "301px",
    viewBox: "0 0 300 301",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "051D8490-E71F-4638-89E0-C29F92A3FFF7@1.00x") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), /*#__PURE__*/React.createElement("g", {
    id: "Pricing---Switzerland",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Pricing---Was-kostest-es-monatlich",
    transform: "translate(-772.000000, -249.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(350.000000, 182.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Dialog-Box-/-Base-/-Default"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Illustration/Pricing/1---SWI",
    transform: "translate(422.000000, 67.000000)"
  }, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#C6E5F7",
    cx: 150,
    cy: 283,
    rx: 150,
    ry: 18
  })), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-Copy",
    fill: "#C6E5F7",
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.473260789,
    cx: 246,
    cy: 273,
    rx: 54,
    ry: 8
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-Copy-2",
    fill: "#C6E5F7",
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.473260789,
    cx: 132.5,
    cy: 281,
    rx: 44.5,
    ry: 8
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-Copy-3",
    fill: "#C6E5F7",
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.473260789,
    cx: 46.5,
    cy: 283,
    rx: 33.5,
    ry: 8
  }), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group-4",
    strokeWidth: 1,
    transform: "translate(192.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M107.879571,51.413681 L106.690815,51.413681 L106.690815,18.8480991 C106.690821,13.849265 104.705043,9.05516879 101.17033,5.5204623 C97.6356174,1.98575581 92.8415178,1.40687458e-13 87.8426836,1.40687458e-13 L18.8481316,1.40687458e-13 C13.8492974,1.40687458e-13 9.05519782,1.98575581 5.52048525,5.5204623 C1.98577267,9.05516879 7.16227059e-13,13.849265 7.16227059e-13,18.8480991 L7.16227059e-13,197.505426 C7.16227059e-13,202.504261 1.98577267,207.298357 5.52048525,210.833063 C9.05519782,214.36777 13.8492974,216.353526 18.8481316,216.353526 L87.8426836,216.353526 C92.8415178,216.353526 97.6356174,214.36777 101.17033,210.833063 C104.705043,207.298357 106.690821,202.504261 106.690815,197.505426 L106.690815,74.59442 L107.879571,74.59442 L107.879571,51.413681 Z",
    id: "Path",
    fill: "#3F3D56",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.679092,18.9796041 L102.679092,197.374093 C102.679092,205.148097 96.3769154,211.450274 88.6029121,211.450274 L19.277318,211.450274 C11.5033177,211.450274 5.20113772,205.148094 5.20113772,197.374093 L5.20113772,18.9796041 C5.20113772,11.205606 11.5033199,4.90342379 19.277318,4.90342379 L27.6873667,4.90342379 C26.8481912,6.96556366 27.0897141,9.31003718 28.3316778,11.1577824 C29.5736416,13.0055275 31.6533369,14.1144716 33.8796867,14.1161156 L73.4059819,14.1161156 C75.6323289,14.1144621 77.7120187,13.0055172 78.9539836,11.1577761 C80.1959484,9.31003509 80.437481,6.96556709 79.5983214,4.90342379 L88.6029121,4.90342379 C96.3769124,4.90342379 102.679092,11.2056038 102.679092,18.9796041 Z",
    id: "Path",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.599997,159.072601 L102.599997,197.417647 C102.599997,205.195056 96.3157911,211.499996 88.5639554,211.499996 L19.4360573,211.499996 C11.6842155,211.499996 5.39999986,205.195062 5.39999986,197.417647 L5.39999986,136.26231 C17.3852847,122.146532 34.7138973,113.710331 53.1825938,113 C71.6512903,112.289669 89.5727753,119.370103 102.599997,132.523867 L102.599997,159.072601 Z",
    id: "Path",
    fill: "#0077B6"
  })), /*#__PURE__*/React.createElement("text", {
    id: 21,
    fontFamily: "Roboto-Medium, Roboto",
    fontSize: 32,
    fontWeight: 400,
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 36.3125,
    y: 161
  }, "21")), /*#__PURE__*/React.createElement("text", {
    id: "oder-mehr",
    fontFamily: "Roboto-Regular, Roboto",
    fontSize: 12,
    fontWeight: "normal",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 26.5517578,
    y: 178
  }, "oder mehr")), /*#__PURE__*/React.createElement("text", {
    id: "MDE",
    opacity: 0.574079241,
    fontFamily: "Roboto-Bold, Roboto",
    fontSize: 15,
    fontWeight: "bold",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 38.3408203,
    y: 198
  }, "MDE")), /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(16.000000, 36.000000)",
    fill: "#585D67",
    fontFamily: "Capitolium2-Bold, Capitolium2",
    fontSize: 48,
    fontWeight: "bold",
    letterSpacing: -1.7,
    opacity: 0.679199219
  }, /*#__PURE__*/React.createElement("text", {
    id: 29
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 4.148,
    y: 36
  }, "29 "))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    strokeWidth: 1,
    transform: "translate(51.000000, 67.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-Copy",
    transform: "translate(37.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M88.2000035,42.1331059 L87.2281022,42.1331059 L87.2281022,15.4458685 C87.2281072,11.3493634 85.6045775,7.42063938 82.7146729,4.5239753 C79.8247684,1.62731121 75.9052163,0 71.8182776,0 L15.4098246,0 C11.3228859,0 7.40333383,1.62731121 4.5134293,4.5239753 C1.62352477,7.42063938 0,11.3493634 0,15.4458685 L0,161.854139 C0,165.950644 1.62352477,169.879368 4.5134293,172.776032 C7.40333383,175.672696 11.3228859,177.300007 15.4098246,177.300007 L71.8182776,177.300007 C75.9052163,177.300007 79.8247684,175.672696 82.7146729,172.776032 C85.6045775,169.879368 87.2281072,165.950644 87.2281022,161.854139 L87.2281022,61.1295386 L88.2000035,61.1295386 L88.2000035,42.1331059 Z",
    id: "Path",
    fill: "#3F3D56",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.7000033,15.1309908 L83.7000033,161.269016 C83.7000033,167.63736 78.5795385,172.800007 72.2632274,172.800007 L15.9367761,172.800007 C9.62046741,172.800007 4.50000018,167.637358 4.50000018,161.269016 L4.50000018,15.1309908 C4.50000018,8.76265099 9.62046922,3.60000014 15.9367761,3.60000014 L22.7698686,3.60000014 C22.0880457,5.28927345 22.284281,7.20983014 23.2933659,8.72347462 C24.3024508,10.2371191 25.9921854,11.1455491 27.8010756,11.1468958 L59.9158519,11.1468958 C61.7247397,11.1455412 63.4144698,10.2371106 64.4235557,8.7234695 C65.4326415,7.20982843 65.6288846,5.28927626 64.9470747,3.60000014 L72.2632274,3.60000014 C78.5795361,3.60000014 83.7000033,8.76264916 83.7000033,15.1309908 Z",
    id: "Path",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.7000033,133.498709 L83.7000033,162.243416 C83.7000033,168.073618 78.5795387,172.800007 72.2632277,172.800007 L15.9367885,172.800007 C9.62047251,172.800007 4.50000018,168.073623 4.50000018,162.243416 L4.50000018,122.274734 C14.2657885,111.693083 28.3853997,105.36903 43.4339682,104.836542 C58.4825367,104.304055 73.0852291,109.611781 83.7000033,119.472275 L83.7000033,133.498709 Z",
    id: "Path",
    fill: "#0077B6"
  })), /*#__PURE__*/React.createElement("text", {
    id: "6.-20.",
    fontFamily: "Roboto-Medium, Roboto",
    fontSize: 20,
    fontWeight: 400,
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 54.4199219,
    y: 143
  }, "6.-20.")), /*#__PURE__*/React.createElement("text", {
    id: "MDE",
    opacity: 0.574079241,
    fontFamily: "Roboto-Bold, Roboto",
    fontSize: 12,
    fontWeight: "bold",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 68.9726562,
    y: 158
  }, "MDE")), /*#__PURE__*/React.createElement("g", {
    id: "Group-2-Copy",
    transform: "translate(0.000000, 24.000000)"
  }, /*#__PURE__*/React.createElement("text", {
    id: 59,
    opacity: 0.679199219,
    fontFamily: "Capitolium2-Bold, Capitolium2",
    fontSize: 38,
    fontWeight: "bold",
    letterSpacing: -1.34583333,
    fill: "#585D67"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 56.1048333,
    y: 28
  }, "59")), /*#__PURE__*/React.createElement("g", {
    id: "Franc",
    transform: "translate(0.000000, 65.000000)",
    fill: "#96999E"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(2.000000, 0.676471)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.18,3.07623208e-13 C2.94,0.0974117647 4.316,0.0974117647 6.108,0.0974117647 L15.26,0.0974117647 C15.26,0.0974117647 15.228,2.79247059 15.356,4.28611765 L15.356,4.28611765 L14.684,4.28611765 C14.652,3.18211765 14.204,2.43529412 13.596,2.07811765 C12.892,1.656 12.252,1.59105882 10.268,1.59105882 L7.644,1.59105882 L7.644,9.54635294 L10.332,9.54635294 C11.484,9.54635294 12.348,9.48141176 12.924,8.99435294 C13.372,8.63717647 13.692,8.02023529 13.756,7.07858824 L13.756,7.07858824 L14.428,7.07858824 C14.428,7.79294118 14.364,8.24752941 14.364,10.2931765 L14.3644781,10.7004433 C14.3685714,12.3638391 14.3982857,12.7493445 14.428,13.4428235 L14.428,13.4428235 L13.756,13.4428235 C13.692,12.5985882 13.436,12.0465882 13.052,11.6894118 C12.38,11.1049412 11.388,11.04 10.268,11.04 L10.268,11.04 L7.644,11.04 L7.644,15.558 L11.3333333,15.5588235 L11.3333333,16.9117647 L7.644,16.911 L7.6443477,17.026452 C7.6505898,18.8243528 7.74212357,19.4714775 8.01915185,19.9083327 L8.06,19.9694118 C8.572,20.7487059 10.012,20.8136471 10.332,20.8136471 L10.332,20.8136471 L10.332,21.4305882 C9.084,21.3656471 6.556,21.2682353 5.436,21.2682353 C3.644,21.2682353 2.876,21.3331765 1.084,21.4305882 L1.084,21.4305882 L1.084,20.8461176 C1.5,20.8461176 2.172,20.6837647 2.652,20.1317647 C3.11731022,19.6040643 3.20802944,18.8625578 3.22453854,16.9115708 L0,16.9117647 L0,15.5588235 L3.228,15.558 L3.228,4.64329412 C3.228,2.68658824 3.14016635,1.94792839 2.85247933,1.46114445 L2.812,1.39623529 C2.556,1.03905882 2.044,0.649411765 1.18,0.584470588 L1.18,0.584470588 Z",
    id: "Combined-Shape"
  })))))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group-Copy-2",
    strokeWidth: 1,
    transform: "translate(0.000000, 125.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M78.4000012,37.4516487 L77.536089,37.4516487 L77.536089,13.7296606 C77.5360933,10.0883227 76.0929559,6.59612373 73.5241519,4.02131127 C70.9553479,1.44649882 67.4713017,0 63.8384674,0 L13.6976215,0 C10.0647873,0 6.58074102,1.44649882 4.01193706,4.02131127 C1.44313309,6.59612373 0,10.0883227 0,13.7296606 L0,143.870342 C0,147.51168 1.44313309,151.003879 4.01193706,153.578691 C6.58074102,156.153504 10.0647873,157.600002 13.6976215,157.600002 L63.8384674,157.600002 C67.4713017,157.600002 70.9553479,156.153504 73.5241519,153.578691 C76.0929559,151.003879 77.5360933,147.51168 77.536089,143.870342 L77.536089,54.3373663 L78.4000012,54.3373663 L78.4000012,37.4516487 Z",
    id: "Path",
    fill: "#3F3D56",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.4000011,13.4497693 L74.4000011,143.350233 C74.4000011,149.010983 69.8484769,153.600002 64.2339783,153.600002 L14.1660228,153.600002 C8.55152638,153.600002 4.00000006,149.010981 4.00000006,143.350233 L4.00000006,13.4497693 C4.00000006,7.78902291 8.55152799,3.20000005 14.1660228,3.20000005 L20.2398827,3.20000005 C19.6338179,4.70157628 19.8082493,6.40873775 20.7052136,7.75419947 C21.602178,9.09966119 23.1041642,9.90715447 24.7120666,9.90835155 L53.2585337,9.90835155 C54.866434,9.9071475 56.3684162,9.09965361 57.2653814,7.75419492 C58.1623465,6.40873623 58.3367849,4.70157878 57.7307316,3.20000005 L64.2339783,3.20000005 C69.8484748,3.20000005 74.4000011,7.78902128 74.4000011,13.4497693 Z",
    id: "Path",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("text", {
    id: 99,
    opacity: 0.679199219,
    fontFamily: "Capitolium2-Bold, Capitolium2",
    fontSize: 32,
    fontWeight: "bold",
    letterSpacing: -1.13333333,
    fill: "#585D67"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 12.8293333,
    y: 52
  }, "99 ")), /*#__PURE__*/React.createElement("path", {
    d: "M74.4000011,115.735772 L74.4000011,143.429417 C74.4000011,149.046436 69.8484771,153.600002 64.2339786,153.600002 L14.1660339,153.600002 C8.55153091,153.600002 4.00000006,149.04644 4.00000006,143.429417 L4.00000006,109.80276 C12.6807006,99.6080314 25.2314658,93.5152196 38.6079708,93.0022027 C51.9844758,92.4891859 64.9646465,97.6028332 74.4000011,107.102774 L74.4000011,115.735772 Z",
    id: "Path",
    fill: "#0077B6"
  }), /*#__PURE__*/React.createElement("text", {
    id: 5,
    fontFamily: "Roboto-Medium, Roboto",
    fontSize: 20,
    fontWeight: 400,
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 33.8164062,
    y: 131
  }, "5")), /*#__PURE__*/React.createElement("text", {
    id: "bis",
    fontFamily: "Roboto-Regular, Roboto",
    fontSize: 12,
    fontWeight: "normal",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 31.4404297,
    y: 109
  }, "bis")), /*#__PURE__*/React.createElement("text", {
    id: "MDE",
    opacity: 0.574079241,
    fontFamily: "Roboto-Bold, Roboto",
    fontSize: 12,
    fontWeight: "bold",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 26.9726562,
    y: 146
  }, "MDE")))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Franc",
    transform: "translate(51.000000, 159.000000)",
    fill: "#96999E",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(2.000000, 0.676471)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.18,3.07623208e-13 C2.94,0.0974117647 4.316,0.0974117647 6.108,0.0974117647 L15.26,0.0974117647 C15.26,0.0974117647 15.228,2.79247059 15.356,4.28611765 L15.356,4.28611765 L14.684,4.28611765 C14.652,3.18211765 14.204,2.43529412 13.596,2.07811765 C12.892,1.656 12.252,1.59105882 10.268,1.59105882 L7.644,1.59105882 L7.644,9.54635294 L10.332,9.54635294 C11.484,9.54635294 12.348,9.48141176 12.924,8.99435294 C13.372,8.63717647 13.692,8.02023529 13.756,7.07858824 L13.756,7.07858824 L14.428,7.07858824 C14.428,7.79294118 14.364,8.24752941 14.364,10.2931765 L14.3644781,10.7004433 C14.3685714,12.3638391 14.3982857,12.7493445 14.428,13.4428235 L14.428,13.4428235 L13.756,13.4428235 C13.692,12.5985882 13.436,12.0465882 13.052,11.6894118 C12.38,11.1049412 11.388,11.04 10.268,11.04 L10.268,11.04 L7.644,11.04 L7.644,15.558 L11.3333333,15.5588235 L11.3333333,16.9117647 L7.644,16.911 L7.6443477,17.026452 C7.6505898,18.8243528 7.74212357,19.4714775 8.01915185,19.9083327 L8.06,19.9694118 C8.572,20.7487059 10.012,20.8136471 10.332,20.8136471 L10.332,20.8136471 L10.332,21.4305882 C9.084,21.3656471 6.556,21.2682353 5.436,21.2682353 C3.644,21.2682353 2.876,21.3331765 1.084,21.4305882 L1.084,21.4305882 L1.084,20.8461176 C1.5,20.8461176 2.172,20.6837647 2.652,20.1317647 C3.11731022,19.6040643 3.20802944,18.8625578 3.22453854,16.9115708 L0,16.9117647 L0,15.5588235 L3.228,15.558 L3.228,4.64329412 C3.228,2.68658824 3.14016635,1.94792839 2.85247933,1.46114445 L2.812,1.39623529 C2.556,1.03905882 2.044,0.649411765 1.18,0.584470588 L1.18,0.584470588 Z",
    id: "Combined-Shape"
  })))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Franc",
    transform: "translate(147.000000, 97.000000)",
    fill: "#96999E",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(2.000000, 0.676471)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.18,3.07623208e-13 C2.94,0.0974117647 4.316,0.0974117647 6.108,0.0974117647 L15.26,0.0974117647 C15.26,0.0974117647 15.228,2.79247059 15.356,4.28611765 L15.356,4.28611765 L14.684,4.28611765 C14.652,3.18211765 14.204,2.43529412 13.596,2.07811765 C12.892,1.656 12.252,1.59105882 10.268,1.59105882 L7.644,1.59105882 L7.644,9.54635294 L10.332,9.54635294 C11.484,9.54635294 12.348,9.48141176 12.924,8.99435294 C13.372,8.63717647 13.692,8.02023529 13.756,7.07858824 L13.756,7.07858824 L14.428,7.07858824 C14.428,7.79294118 14.364,8.24752941 14.364,10.2931765 L14.3644781,10.7004433 C14.3685714,12.3638391 14.3982857,12.7493445 14.428,13.4428235 L14.428,13.4428235 L13.756,13.4428235 C13.692,12.5985882 13.436,12.0465882 13.052,11.6894118 C12.38,11.1049412 11.388,11.04 10.268,11.04 L10.268,11.04 L7.644,11.04 L7.644,15.558 L11.3333333,15.5588235 L11.3333333,16.9117647 L7.644,16.911 L7.6443477,17.026452 C7.6505898,18.8243528 7.74212357,19.4714775 8.01915185,19.9083327 L8.06,19.9694118 C8.572,20.7487059 10.012,20.8136471 10.332,20.8136471 L10.332,20.8136471 L10.332,21.4305882 C9.084,21.3656471 6.556,21.2682353 5.436,21.2682353 C3.644,21.2682353 2.876,21.3331765 1.084,21.4305882 L1.084,21.4305882 L1.084,20.8461176 C1.5,20.8461176 2.172,20.6837647 2.652,20.1317647 C3.11731022,19.6040643 3.20802944,18.8625578 3.22453854,16.9115708 L0,16.9117647 L0,15.5588235 L3.228,15.558 L3.228,4.64329412 C3.228,2.68658824 3.14016635,1.94792839 2.85247933,1.46114445 L2.812,1.39623529 C2.556,1.03905882 2.044,0.649411765 1.18,0.584470588 L1.18,0.584470588 Z",
    id: "Combined-Shape"
  })))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Franc",
    transform: "translate(262.000000, 46.000000)",
    fill: "#96999E",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(2.555556, 0.852941)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.50777778,3.8787274e-13 C3.75666667,0.122823529 5.51488889,0.122823529 7.80466667,0.122823529 L19.4988889,0.122823529 C19.4988889,0.122823529 19.458,3.52094118 19.6215556,5.40423529 L19.6215556,5.40423529 L18.7628889,5.40423529 C18.722,4.01223529 18.1495556,3.07058824 17.3726667,2.62023529 C16.4731111,2.088 15.6553333,2.00611765 13.1202222,2.00611765 L9.76733333,2.00611765 L9.76733333,12.0367059 L13.202,12.0367059 C14.674,12.0367059 15.778,11.9548235 16.514,11.3407059 C17.0864444,10.8903529 17.4953333,10.1124706 17.5771111,8.92517647 L17.5771111,8.92517647 L18.4357778,8.92517647 C18.4357778,9.82588235 18.354,10.3990588 18.354,12.9783529 L18.3546109,13.4918633 C18.3598413,15.5891885 18.3978095,16.0752605 18.4357778,16.9496471 L18.4357778,16.9496471 L17.5771111,16.9496471 C17.4953333,15.8851765 17.1682222,15.1891765 16.6775556,14.7388235 C15.8188889,14.0018824 14.5513333,13.92 13.1202222,13.92 L13.1202222,13.92 L9.76733333,13.92 L9.767,19.617 L14.4814815,19.6176471 L14.4814815,21.3235294 L9.767,21.323 L9.76777761,21.4681351 C9.77579921,23.7480074 9.8940537,24.5602711 10.2527855,25.1112277 L10.2988889,25.1788235 C10.9531111,26.1614118 12.7931111,26.2432941 13.202,26.2432941 L13.202,26.2432941 L13.202,27.0211765 C11.6073333,26.9392941 8.37711111,26.8164706 6.946,26.8164706 C4.65622222,26.8164706 3.67488889,26.8983529 1.38511111,27.0211765 L1.38511111,27.0211765 L1.38511111,26.2842353 C1.91666667,26.2842353 2.77533333,26.0795294 3.38866667,25.3835294 C3.98311653,24.7182947 4.09910457,23.783581 4.12023164,21.3246899 L0,21.3235294 L0,19.6176471 L4.124,19.617 L4.12411298,5.56434753 C4.11517959,3.30074958 3.99636545,2.42180942 3.63902969,1.83268136 L3.59311111,1.76047059 C3.266,1.31011765 2.61177778,0.818823529 1.50777778,0.736941176 L1.50777778,0.736941176 Z",
    id: "Combined-Shape"
  })))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPricingLicense1Switzerland);
export default __webpack_public_path__ + "static/media/pricing_license_1_switzerland.940cf569e4baeeb4cf7699965e50c9c4.svg";
export { ForwardRef as ReactComponent };